import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import ColorModeIconDropdown from '../../shared-theme/ColorModeIconDropdown';
import LanguageIconDropdown from '../../shared-theme/LanguageIconDropdown';
import { useFontScale } from '../contexts/FontScaleContext';

export default function Header() {
  const { scale, cycleScale } = useFontScale();

  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: 'none', md: 'flex' },
        width: '100%',
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'flex-end',
        maxWidth: { sm: '100%', md: '1700px' },
        pt: 1.5,
      }}
      spacing={2}
    >
      <Stack direction="row" sx={{ gap: 1 }} alignItems="center">
        <Tooltip title={`Размер шрифта: ${Math.round(scale * 100)}%`}>
          <IconButton
            onClick={cycleScale}
            color="inherit"
            size="small"
            aria-label="Увеличить размер шрифта"
          >
            <FormatSizeIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <LanguageIconDropdown />
        <ColorModeIconDropdown />
      </Stack>
    </Stack>
  );
}
